import { render, staticRenderFns } from "./PagosListaItem.vue?vue&type=template&id=86b6e66c&"
import script from "./PagosListaItem.vue?vue&type=script&lang=js&"
export * from "./PagosListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports